import {useRef} from 'react';
import {Box} from '@chakra-ui/react';
// https://react-slick.neostack.com/docs/api
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Slider from 'react-slick';
import {SlickControls} from './timeline-slider';

interface AssetDisplayCardCarouselProps {
  cards?: React.ReactElement<any>[];
  enableAnimation?: boolean;
  cardTypeName: string;
  cardWidth: number | string;
}
export const BasicCardCarousel: React.FC<AssetDisplayCardCarouselProps> = ({
  cards,
  enableAnimation = false,
  cardWidth,
}) => {
  const slider = useRef(null);

  const settings = {
    className: 'slider variable-width',
    infinite: true,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
  };

  return (
    <Box pos="relative" width="100%" pt="40px">
      <Box position="absolute" right="0px" top="-45px">
        <SlickControls
          enableAnimation={enableAnimation}
          next={() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line no-unused-expressions
            slider?.current?.slickNext();
          }}
          prev={() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line no-unused-expressions
            slider?.current?.slickPrev();
          }}
        />
      </Box>
      <Box width="100%">
        <Slider ref={slider} {...settings}>
          {cards &&
            cards.map((card, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} style={{width: cardWidth}}>
                {card}
              </div>
            ))}
        </Slider>
      </Box>
    </Box>
  );
};
